import { render, staticRenderFns } from "./CMCourseCard.vue?vue&type=template&id=af7a1312&scoped=true&lang=pug&"
import script from "./CMCourseCard.vue?vue&type=script&lang=js&"
export * from "./CMCourseCard.vue?vue&type=script&lang=js&"
import style0 from "./CMCourseCard.vue?vue&type=style&index=0&id=af7a1312&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af7a1312",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
